module.exports = __webpack_public_path__ + "img/SKMJ_place4.7c5cf365.png";